export const NETWORK_ERROR_MODAL_TITLE = 'Something went wrong.';
export const NETWORK_ERROR_MODAL_TEXT = `
  Something went wrong. If this error persists, please contact support@customers.ai
`;

export const CONNECTVITIY_ERROR_MODAL_TITLE =
  'We are having trouble connecting to our servers!';
export const CONNECTVITIY_ERROR_MODAL_TEXT = `
  Please ensure that your internet connection is working correctly and try again.
`;
